import { Alert, Form, Typography } from 'antd'
import React, { forwardRef, useEffect, useMemo, useCallback, useState } from 'react'
import { useGlobalFilterContext } from 'contexts/GlobalFilterContext';
import { JfrogXraySeverityFilterAPI } from 'restAPI/ToolsIntegrationAPI'
import { ALL_SEVERITIES, SEVERITY_NAMES } from 'views/Findings/Constants'
import { FieldTypes, generateFormFields } from 'utils/formUtils'
import AppLoader from 'components/AppLoader';

const JfrogXraySeverityFilter = forwardRef(({ toolName }, ref) => {
    const [form] = Form.useForm();
    const { globalFilterHash } = useGlobalFilterContext();
    const [loading, setLoading] = useState(true);

    const DEFAULT_SEVERITIES = [SEVERITY_NAMES.critical, SEVERITY_NAMES.high, SEVERITY_NAMES.medium];

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            const resData = await JfrogXraySeverityFilterAPI.getConfiguredSeverityFilters().promise;
            const severities = resData?.config?.severities || DEFAULT_SEVERITIES;
            form.setFieldsValue({
                severities: severities
            });
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, [form]);

    useEffect(() => {
        fetchData();
    }, [globalFilterHash, fetchData]);

    const fields = useMemo(() => [{
        name: "severities",
        label: <Typography.Text>JFrog Xray Severity Filter</Typography.Text>,
        placeholder: "Select severities to include",
        type: FieldTypes.MULTI_SELECT,
        options: parseSelectOptions(ALL_SEVERITIES),
        colSpan: 16,
        props: {
            allowClear: false,
        },
        rules: [
            {
                required: true,
                message: 'Please select at least one severity'
            }
        ],
        help: "Select which severities to include when pulling data from JFrog Xray."
    }], []);

    return (
            <Alert direction="vertical" className="m-b-m"
                description={
                    <div> 
                        {
                        loading ? <AppLoader /> :
                        <Form
                            form={form}
                            ref={ref}
                            style={{ minWidth: 600 }}
                            layout="vertical"
                        >
                            {generateFormFields(fields)}
                        </Form>
                        }
                    </div>
                }
            />
    )
})

export default JfrogXraySeverityFilter;

const parseSelectOptions = (options = []) => {
    return options.map(option => ({
        label: option,
        value: option
    }));
}